import { SearchHistory } from '@search/services/SearchHistory';
export const useSearchHistory = () => reactive(new SearchHistory());
